// src/Chat/ChatPage.jsx
import React, { useState } from 'react';
import { ChatProvider } from '../context/SignamRContext';
import ChatLayout from './ChatLayout';

const ChatPage = ({ brojPoruka, setBrojPoruka }) => {
  const [activeChat, setActiveChat] = useState(null);

  return (
    <ChatProvider brojPoruka={brojPoruka} setBrojPoruka={setBrojPoruka}>
      <ChatLayout activeChat={activeChat} setActiveChat={setActiveChat} />
    </ChatProvider>
  );
};

export default ChatPage;
